module.exports = __webpack_public_path__ + "static/media/standings.8eaf415d.svg";